<template>
  <div class="navbar">
    <div class="container">
      <div class="nav">
        <router-link class="nav-logo" :to="'/'">
          <img
            src="@/assets/logo.png"
            alt="brand-logo"
            class="nav-logo-image"
          />
        </router-link>
        <div class="nav-menu">
          <ul class="nav-menu-links">
            <a
              id="home-link"
              href="https://routeline.com/pages/membership-overview"
              exact
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              Memberships
            </a>
            <a
              href="https://routeline.com/pages/our-fleet"
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              Vehicles
            </a>
            <!-- <a
              href="https://routeline.com/pages/reservations"
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              Book Nightly
            </a> -->
          </ul>
        </div>
        <div class="nav-toggler" @click="toggle = !toggle">
          <i class="fa fa-bars"></i>
        </div>
      </div>

      <div class="mobile-menu pt-4 pb-4">
          <ul :class="`mobile-menu-links ${toggle ? 'show' : 'hide'}`">
            <a
              id="home-link"
              href="https://routeline.com/pages/membership-overview"
              exact
              active-class="mobile-active"
              tag="li"
              class="mobile-menu-links-link"
            >
              Memberships
            </a>
            <a
              href="https://routeline.com/pages/our-fleet"
              active-class="mobile-active"
              tag="li"
              class="mobile-menu-links-link"
            >
              Vehicles
            </a>
            <a
              href="https://routeline.com/pages/reservations"
              active-class="mobile-active"
              tag="li"
              class="mobile-menu-links-link"
            >
              Book Nightly
            </a>
          </ul>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'
import firebase from 'firebase/compat/app'
// import Button from '../ButtonDefault.vue'

export default Vue.extend({
  data: () => ({
    toggle: false
  }),
  // components: { Button },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch('logout')
          this.$snackbar("You've been logged out!", 'success')
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
})
</script>

<style scoped lang="scss">
.navbar {
  // position: fixed;
  background-color: #000;
  color: var(--white);
  width: 100%;
  padding: 12px 0;
  z-index: 1;
  font-weight: 500;
  left: 0;
  right: 0;
}
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  // background: #000;

  &-toggler {
    font-size: 26px;
    visibility: hidden;
  }

  &-logo {
    &-image {
      width: 130px;
    }
  }
  &-menu {
    margin-left: -110px;

    &-links {
      display: flex;
      column-gap: 25px;

      &-link {
        list-style-type: none;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        text-decoration: none;
        color: #fff;

        &:hover {
          color: var(--white);
        }

        &::after {
          position: absolute;
          content: '';
          display: block;
          width: 0;
          height: 3px;
          background: var(--accent);
          transition: all 0.3s ease;
        }

        &:hover::after {
          position: absolute;
          content: '';
          display: block;
          width: 100%;
          height: 3px;
          background: var(--accent);
          transition: all 0.3s ease;
        }
      }
    }
  }
  &-button {
    display: flex;
    align-items: center;
    column-gap: 20px;

    &-image {
      width: 35px;
      cursor: pointer;
    }
  }

  &-active {
    color: var(--white);

    &::after {
      position: absolute;
      content: '';
      display: block;
      width: 100%;
      height: 3px;
      background: var(--accent);
      transition: all 0.3s ease;
    }
  }
}

.mobile {
  justify-content: center;
  display: none;

  &-menu {
    &-links {
      display: flex;
      flex-direction: column;
      column-gap: 25px;
      // display: none;

      &-link {
        list-style-type: none;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        text-decoration: none;
        color: #fff;

        &:hover {
          color: var(--white);
        }

        &::after {
          position: absolute;
          content: '';
          display: block;
          width: 0;
          height: 3px;
          background: var(--accent);
          transition: all 0.3s ease;
        }

        &:hover::after {
          position: absolute;
          content: '';
          display: block;
          width: 100%;
          height: 3px;
          background: var(--accent);
          transition: all 0.3s ease;
        }
      }
    }
  }
}

.show {
  display: flex;
}
.hide {
  display: none;
}

@media screen and (max-width: 768px) {
  .nav {
    &-toggler {
      visibility: visible;
    }
    &-menu {
      &-links {
        display: none;
      }
    }
  }
}
</style>